<template>
  <div class="study-rankings">
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="wrap">
          <div class="title">
            <div>
              <i class="iconfont icon-happy"></i>
            </div>
            <div class="text">
              <span>今日学习时间（秒）<br>（不要小看勤奋）</span>
            </div>
          </div>
          <div class="list">
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal7781)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal7781)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal7781)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal77jkjkjk81)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="wrap">
          <div class="title">
            <div>
              <i class="iconfont icon-happy"></i>
            </div>
            <div class="text">
              <span>今日学习时间（秒）<br>（不要小看勤奋）</span>
            </div>
          </div>
          <div class="list">
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal7781)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal7781)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal7781)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal7781)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="wrap">
          <div class="title">
            <div>
              <i class="iconfont icon-happy"></i>
            </div>
            <div class="text">
              <span>今日学习时间（秒）<br>（不要小看勤奋）</span>
            </div>
          </div>
          <div class="list">
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal7781)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal7781)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal7781)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal7781)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="wrap">
          <div class="title">
            <div>
              <i class="iconfont icon-happy"></i>
            </div>
            <div class="text">
              <span>今日学习时间（秒）<br>（不要小看勤奋）</span>
            </div>
          </div>
          <div class="list">
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal7781)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal7781)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal7781)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal7781)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="wrap">
          <div class="title">
            <div>
              <i class="iconfont icon-happy"></i>
            </div>
            <div class="text">
              <span>今日学习时间（秒）<br>（不要小看勤奋）</span>
            </div>
          </div>
          <div class="list">
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal7781)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
                <div class="honor">
                  <span>三级战神</span>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal7781)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
                <div class="honor">
                  <span>三级战神</span>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal7781)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
                <div class="honor">
                  <span>三级战神</span>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="user">
                <span>1.</span>
                <span class="name">张玲敏(wordal7781)</span>
              </div>
              <div class="time">
                <div class="score">
                  <i class="iconfont icon-happy"></i>
                  <span>4985</span>
                </div>
                <div class="honor">
                  <span>三级战神</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  // Radio,
  // Select,
  // Option,
  // Button,
  // Tag,
  Row,
  Col,
  // Pagination,
} from 'element-ui';


export default {
  components: {
    // ElRadio: Radio,
    // ElSelect: Select,
    // ElOption: Option,
    // ElButton: Button,
    // ElTag: Tag,
    ElRow: Row,
    ElCol: Col,
    // ElPagination: Pagination,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
  },
  created() {
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .study-rankings {
    padding: 20px;
    .el-row{
      .wrap {
        margin-bottom: 20px;
        border: 1px solid $border-color;
        .title {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          padding: 20px;
          background: $primary;
          color: #fff;
          font-size: $font-size-lg;
          .iconfont {
            font-size: 24px;
          }
          .text {
            margin-left: 10px;
            line-height: 20px;
          }
        }
        .list {
          .item {
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;
            justify-content: space-between;
            line-height: 40px;
            border-bottom: 1px dotted $border-color;
            .user {
              width: 150px;
              padding-left: 10px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              .name {
                margin-left: 5px;
              }
            }
            &:nth-child(1),&:nth-child(2),&:nth-child(3) {
              .user {
                .name {
                  color: orange
                }
              }
            }
            &:last-child{
              border-bottom: 0;
            }
            .time {
              padding-right: 10px;
              display: flex;
              align-items: center;
              flex-direction: row;
              .score {
                .iconfont{
                  margin-right: 5px;
                }
              }
              .honor {
                margin-left: 30px;
                color: $danger;
              }
            }
          }
        }
      }
    }
  }
</style>
